import { UnknownAction } from "redux";
import { isRoomsAction } from "../actions/Rooms.js";
import { Room } from "../types/index.js";

const reducer = (state: Room[] = [], action: UnknownAction) => {
  if (!isRoomsAction(action)) {
    return state;
  }

  switch (action.type) {
    case "GET_ROOMS_SUCCESS":
      return action.rooms;

    default:
      return state;
  }
};

export default reducer;
